import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.user.as');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-user-as',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.user.as/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageUserAsComponent implements OnInit, OnDestroy {

    @Input() title: any;

    public type: string | null = null;
    public postId: string | null = null;

    private routerSub: Subscription | null = null;

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) {}

    public async ngOnInit() {
        await this.service.init();
        this.applyRoute();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.applyRoute();
                await this.service.render();
            }
        });
    }

    private applyRoute() {
        this.type = WizRoute.segment.type || null;
        this.postId = WizRoute.segment.id || null;
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }
}

export default PageUserAsComponent;